import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'
import { guid } from '../getCalculatedValue'
import { classifyArray, getSameAttribute } from '../handleData'
import { publicPickScope } from '@/utils/tabPages'
import { scoreOverflowMessage } from '@/utils/paperCompose'

function questionFormName(step) {
  const s = step || ''
  if (s.indexOf('questionLibrary') === 0) return 'questionLibrary'
  if (s.indexOf('publicQuestions') === 0) return 'publicQuestions'
  if (s === 'questionInfo') return 'question'
  return 'paperQuestion'
}

/** 试卷试题列表：在线考试用 currentRow.paper，试卷库/公共试卷库用各自 name */
function resolvePaperCurrentRow(params) {
  const cr = (params && params.state && params.state.currentRow) || {}
  const paper =
    cr.paper ||
    cr.paperLibrary ||
    cr.publicPapers ||
    (params.state &&
      params.state.onlineExam &&
      params.state.onlineExam.paperInfo) ||
    null
  return paper && typeof paper === 'object' ? paper : null
}

const options = {
  name: 'options',
  title: '设置题目选项或答案',
  formParams: (params) => {
    var formName = questionFormName(params.step)
    return params.state.formValues[formName] &&
      params.state.formValues[formName].optionsForm
      ? params.state.formValues[formName].optionsForm
      : {
          optionA: '',
          optionB: '',
          optionC: '',
          optionD: '',
          optionE: '',
          answer: ''
        }
  },
  formData: (params) => {
    var formData = []
    var options = []
    for (const key in params.formValues) {
      if (Object.hasOwnProperty.call(params.formValues, key)) {
        if (key !== 'answer') {
          const field = {
            key: key,
            value: key,
            label: '选项' + key.slice(-1),
            type: 'input',
            span: 18
          }
          formData.push(field)
          params.formValues[key] && options.push(field)
        }
      }
    }
    formData.push(
      {
        key: 'answer',
        label: '正确答案',
        type: 'select',
        options: options,
        multiple: true,
        checkByValue: true,
        span: 18
      },
      {
        buttons: [
          {
            name: '添加选项',
            icon: 'el-icon-plus',
            type: 'primary'
          }
        ],
        type: 'button',
        span: 18
      }
    )
    return formData
  }
}
const imgTables = {
  name: 'imgTables',
  title: (params) => {
    return params.pageStatus === 'content' ? '编辑题干图表' : '编辑解析图表'
  },
  formParams: (params) => {
    var formName = questionFormName(params.step)
    return params.pageStatus === 'content'
      ? {
          fileLists: {
            img:
              params.state.formValues[formName] &&
              params.state.formValues[formName].contentImgUrls
                ? params.state.formValues[formName].contentImgUrls.map(
                    (img) => {
                      return { uid: guid(), url: img }
                    }
                  )
                : []
          }
        }
      : {
          fileLists: {
            img:
              params.state.formValues[formName] &&
              params.state.formValues[formName].analysisImgUrls
                ? params.state.formValues[formName].analysisImgUrls.map(
                    (img) => {
                      return { uid: guid(), url: img }
                    }
                  )
                : []
          }
        }
  },
  formData: [
    {
      type: 'tag',
      tag: '请按顺序依次上传图片，表格请截图为图片上传',
      span: 24
    },
    {
      key: 'img',
      label: (params) => {
        return params.pageStatus === 'content' ? '题干图表' : '解析图表'
      },
      type: 'upload',
      autoUpload: false,
      span: 24
    }
  ]
}
const uploadQuestion = {
  name: 'uploadQuestion',
  title: '导入题目',
  width: '70%',
  upload: true,
  fileTpye: 'word',
  upLoadFun: 'onlineExam/addQuestion',
  getParentFun: (params) => {
    return params.step === 'questionList'
      ? 'onlineExam/getQuestionList'
      : 'onlineExam/getPaperInfo'
  },
  expandColumn: true,
  columns: [
    {
      label: '题目类型',
      prop: 'questionType',
      width: '100px',
      tag: (params) => {
        return params.dictionarys.questionType
      }
    },
    {
      label: '题目难度',
      prop: 'questionDifficulty',
      width: '100px',
      tag: (params) => {
        return params.dictionarys.difficulty
      }
    },
    {
      label: '题目内容',
      width: '500px',
      prop: 'content',
      align: 'left',
      overflow: false
    },
    {
      label: '题目权限',
      prop: 'questionAccess',
      tag: (params) => {
        return params.dictionarys.access
      }
    },
    { prop: 'status', label: '数据状态', width: '', overflow: false },
    {
      label: '操作',
      buttons: setTableButtons(['删除']),
      width: '80px'
    }
  ]
}

const onlineExam = {
  pageTabs: [
    /* {
      label: '考试管理',
      theme: 'onlineExam',
      step: 'examList',
      stepLabel: '考试管理列表',
      checkFun: 'onlineExam/getExamList'
    }, */
    {
      label: '试卷管理',
      theme: 'onlineExam',
      step: 'paperList',
      stepLabel: '试卷管理列表',
      checkFun: 'onlineExam/getPapersList'
    },
    {
      label: '题库管理',
      theme: 'onlineExam',
      step: 'questionList',
      stepLabel: '题库管理列表',
      checkFun: 'onlineExam/getQuestionList'
    }
  ],
  paper: {
    name: 'paper',
    componentTypes: ['navigate', 'pageTabs', 'check', 'tables', 'stepForm'], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'onlineExam/addPaper',
    editFun: 'onlineExam/editPaper',
    confirmFun: 'onlineExam/confirmPaper',
    getListFun: 'onlineExam/getPapersList',
    deleteFun: 'onlineExam/deletePaper',
    detailPage: () => {
      const pages = []
      pages.push({
        buttonName: '公共试卷库',
        type: 'path',
        path: '/workbench/publicPapers'
      })
      pages.push(
        {
          buttonName: '新增',
          name: 'paper',
          type: 'stepForm',
          theme: 'onlineExam',
          step: 'paperInfo',
          label: '新增试卷信息'
        },
        {
          buttonName: '编辑',
          name: 'paper',
          type: 'stepForm',
          theme: 'onlineExam',
          step: 'paperInfo',
          label: '编辑试卷信息',
          checkType: 'checkByUid',
          checkFun: 'onlineExam/getPaperInfo'
        },
        {
          buttonName: '试题信息',
          name: 'paperQuestion',
          type: 'tables',
          theme: 'onlineExam',
          step: 'paperQuestionList',
          label: '试卷试题列表',
          checkType: 'checkByUid',
          checkFun: 'onlineExam/getPaperInfo'
        }
      )
      return pages
    },
    headButtons: () => {
      return setCheckButtons([
        { name: '公共试卷库', icon: 'el-icon-document', type: '' },
        '新增'
      ])
    },
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      scope: 'orgOwned',
      paperType: [],
      applicableUsers: [],
      paperStatus: '',
      paperDifficulty: '',
      query: ''
    },
    selectData: [
      {
        key: 'paperType',
        label: '试卷类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.paperType
        },
        multiple: true,
        span: 8
      },
      {
        key: 'applicableUsers',
        label: '适用对象',
        type: 'select',
        options: (params) => {
          return params.dictionarys.applicableUsers
        },
        multiple: true,
        span: 8
      },
      {
        key: 'questionType',
        label: '包含题型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.questionType
        },
        multiple: true,
        span: 8
      },
      {
        key: 'paperDifficulty',
        label: '试卷难度',
        type: 'select',
        options: (params) => {
          return params.dictionarys.difficulty
        },
        span: 8
      },
      {
        key: 'paperStatus',
        label: '试卷状态',
        type: 'select',
        options: (params) => {
          return params.dictionarys.paperStatus
        },
        checkByValue: true,
        span: 8
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '试卷主题/考点标签',
        span: 8
      }
    ],
    expandColumn: true,
    rowData: (params) => {
      return params.state.onlineExam.papersList.result
    },
    rowTotal: (params) => {
      return params.state.onlineExam.papersList.totalSize
    },
    columns: [
      { label: '试卷主题', prop: 'paperTitle', width: '240px' },
      {
        label: '试卷状态',
        prop: 'paperStatus',
        tag: (params) => {
          return params.dictionarys.paperStatus
        }
      },
      {
        label: '试卷权限',
        prop: 'paperAccess',
        tag: (params) => {
          return params.dictionarys.access
        }
      },
      {
        label: '试卷难度',
        prop: 'paperDifficulty',
        tag: (params) => {
          return params.dictionarys.difficulty
        }
      },
      { label: '推荐时限', prop: 'paperTimeLimit' },
      { label: '试卷总分', prop: 'paperTotalScore' },
      { label: '及格比例', prop: 'passingScore' },
      { label: '使用次数', prop: 'usageCount' },
      {
        label: '试题信息',
        prop: 'questionInfo',
        drillDown: true,
        overflow: false,
        width: '450px',
        tooltip: {
          tipValue: '点击添加或修改试题'
        }
      },
      {
        label: '操作',
        width: '220px',
        buttons: setTableButtons(['编辑', '删除', '确认'])
      }
    ],
    hasPagination: true,
    formParams: {
      orgUid: '',
      paperTitle: '',
      paperAccess: '公开',
      paperDescription: '',
      paperType: [],
      examinationLabels: '',
      applicableUsers: [],
      paperDifficulty: '简单',
      paperTimeLimit: null,
      paperTotalScore: 100,
      passingScore: 60,
      paperStatus: '新建'
    },
    formRules: {
      paperTitle: [
        { required: true, message: '试卷主题不能为空', trigger: 'blur' }
      ],
      questionAccess: [
        { required: true, message: '试卷权限不能为空', trigger: 'blur' }
      ],
      paperType: [
        {
          required: true,
          type: 'array',
          message: '试卷类型不能为空',
          trigger: 'change'
        }
      ],
      applicableUsers: [
        {
          required: true,
          type: 'array',
          message: '适用对象不能为空',
          trigger: 'change'
        }
      ],
      paperDifficulty: [
        { required: true, message: '试卷难度不能为空', trigger: 'blur' }
      ],
      paperTimeLimit: [
        {
          required: true,
          type: 'number',
          message: '推荐时限不能为空',
          trigger: 'blur'
        }
      ],
      passingScore: [
        {
          required: true,
          type: 'number',
          message: '及格比例不能为空',
          trigger: 'blur'
        }
      ]
    },
    formData: {
      card: '试卷基本信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        { key: 'paperTitle', label: '试卷主题', type: 'input' },
        {
          key: 'paperAccess',
          label: '试卷权限',
          type: 'select',
          options: (params) => {
            return params.dictionarys.access
          }
        },
        {
          key: 'paperDifficulty',
          label: '试卷难度',
          type: 'select',
          options: (params) => {
            return params.dictionarys.difficulty
          }
        },
        {
          key: 'paperTimeLimit',
          label: '推荐时限',
          type: 'input',
          number: true,
          inputButton: '分钟'
        },
        {
          key: 'paperTotalScore',
          label: '试卷总分',
          type: 'input',
          number: true,
          disabled: (params) => {
            return params.pageStatus === 'edit'
          }
        },
        {
          key: 'passingScore',
          label: '及格比例',
          type: 'input',
          number: true,
          inputButton: '%'
        },
        {
          key: 'paperType',
          label: '试卷类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.paperType
          },
          multiple: true
        },
        { key: 'examinationLabels', label: '考点标签', type: 'input' },
        {
          key: 'applicableUsers',
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return params.dictionarys.applicableUsers
          },
          multiple: true
        },
        {
          key: 'paperDescription',
          label: '试卷简述',
          type: 'input',
          inputType: 'textarea',
          autosize: { minRows: 2, maxRows: 4 },
          maxlength: 100
        }
      ]
    }
  },
  question: {
    name: 'question',
    componentTypes: [
      'navigate',
      'pageTabs',
      'check',
      'tables',
      'stepForm',
      'dialogTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    addFun: 'onlineExam/addQuestion',
    editFun: 'onlineExam/editQuestion',
    getListFun: 'onlineExam/getQuestionList',
    deleteFun: 'onlineExam/deleteQuestion',
    detailPage: () => {
      const pages = [
        {
          buttonName: '新增',
          name: 'question',
          type: 'stepForm',
          theme: 'onlineExam',
          step: 'questionInfo',
          label: '新增题目'
        }
      ]
      pages.push({
        buttonName: '公共试题库',
        type: 'path',
        path: '/workbench/publicQuestions?from=question'
      })
      pages.push(
        {
          buttonName: '导入题目',
          type: 'path',
          path: '/workbench/questionImport'
        },
        {
          buttonName: '编辑',
          name: 'question',
          type: 'stepForm',
          theme: 'onlineExam',
          step: 'questionInfo',
          label: '编辑题目',
          checkType: 'checkByUid',
          checkFun: 'onlineExam/getQuestionInfo'
        },
        {
          buttonName: '重置难度',
          name: 'resetDifficulty',
          type: 'dialogForm',
          pageStatus: 'add'
        },
        {
          buttonName: '加标签',
          name: 'batchTagLabels',
          type: 'dialogForm',
          pageStatus: 'add'
        },
        {
          buttonNames: ['设置题目选项', '设置题目答案'],
          name: 'options',
          type: 'dialogForm'
        },
        {
          buttonNames: ['编辑题干图表', '编辑解析图表'],
          name: 'imgTables',
          type: 'dialogForm'
        }
      )
      return pages
    },
    headButtons: () => {
      return setCheckButtons([
        { name: '公共试题库', icon: 'el-icon-collection', type: '' },
        '新增',
        { name: '重置难度', icon: 'el-icon-refresh', type: '' },
        '审核通过',
        { name: '加标签', icon: 'el-icon-price-tag', type: '' },
        '批量删除',
        '导入题目',
        { name: '下载导入模板', type: '' }
      ])
    },
    queryParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      scope: 'orgOwned',
      knowledgeType: [],
      applicableUsers: [],
      questionType: '',
      questionDifficulty: '',
      query: ''
    },
    selectData: [
      {
        key: 'knowledgeType',
        label: '知识点类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.dataType
        },
        multiple: true,
        placeholder: '可选择多个要查询的相关知识点类型',
        span: 12
      },
      {
        key: 'applicableUsers',
        label: '适用对象',
        type: 'select',
        options: (params) => {
          return params.dictionarys.applicableUsers
        },
        multiple: true,
        placeholder: '可选择多个要查询的相关适用对象',
        span: 12
      },
      {
        key: 'questionType',
        label: '题目类型',
        type: 'select',
        options: (params) => {
          return params.dictionarys.questionType
        },
        span: 8
      },
      {
        key: 'questionDifficulty',
        label: '题目难度',
        type: 'select',
        options: (params) => {
          return params.dictionarys.difficulty
        },
        span: 8
      },
      {
        key: 'query',
        label: '关键词',
        type: 'input',
        placeholder: '知识点标签',
        span: 8
      }
    ],
    expandColumn: true,
    rowData: (params) => {
      return params.state.onlineExam.questionList.result
    },
    rowTotal: (params) => {
      return params.state.onlineExam.questionList.totalSize
    },
    columns: [
      {
        label: '题目类型',
        prop: 'questionType',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.questionType
        }
      },
      {
        label: '题目难度',
        prop: 'questionDifficulty',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.difficulty
        }
      },
      {
        label: '题目分值',
        width: '80px',
        prop: 'questionScore'
      },
      {
        label: '题目内容',
        prop: 'content',
        minWidth: '480px',
        align: 'left',
        overflow: false
      },
      {
        label: '知识点类型',
        prop: 'knowledgeTypes',
        minWidth: '140px',
        overflow: false,
        overflowWidth: true
      },
      {
        label: '适用对象',
        prop: 'applicableUsersText',
        minWidth: '120px',
        overflow: false,
        overflowWidth: true
      },
      {
        label: '审核状态',
        prop: 'reviewStatusText',
        width: '100px',
        tag: () => [
          { label: '已审核', value: '已审核', type: 'success' },
          { label: '存疑', value: '存疑', type: 'warning' }
        ]
      },
      {
        label: '题目权限',
        prop: 'questionAccess',
        width: '100px',
        tag: (params) => {
          return params.dictionarys.access
        }
      },
      { label: '答错/答题', prop: 'useInfo', width: '120px' },
      {
        label: '操作',
        width: '200px',
        buttons: setTableButtons(['编辑', '删除'])
      }
    ],
    hasPagination: true,
    selectColumn: true,
    addArray: true,
    formParams: {
      uid: guid(),
      orgUid: (params) => {
        return params.userName === 'dpnadmin' ? '' : params.orgValue
      },
      questionAccess: '公开',
      questionType: '单选题',
      knowledgeType: [],
      knowledgeLabels: '',
      applicableUsers: [],
      questionDifficulty: '简单',
      content: '',
      questionContent: '',
      options: [],
      correctAnswer: [],
      analysis: '',
      questionAnalysis: '',
      score: 2
    },
    formRules: {
      questionAccess: [
        { required: true, message: '题目权限不能为空', trigger: 'blur' }
      ],
      questionType: [
        { required: true, message: '题目类型不能为空', trigger: 'blur' }
      ],
      knowledgeType: [
        {
          required: true,
          type: 'array',
          message: '知识点类型不能为空',
          trigger: 'change'
        }
      ],
      applicableUsers: [
        {
          required: true,
          type: 'array',
          message: '适用对象不能为空',
          trigger: 'change'
        }
      ],
      questionDifficulty: [
        { required: true, message: '题目难度不能为空', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '题目内容不能为空', trigger: 'blur' }
      ],
      option: [
        {
          required: (params) => {
            return (
              params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
            )
          },
          message: '选项不能为空',
          trigger: 'change'
        }
      ],
      answers: [
        {
          required: true,
          message: '正确答案不能为空',
          trigger: 'change'
        },
        {
          validator: (params) => {
            return params.validate.validateAnswers
          },
          trigger: 'change'
        }
      ],
      score: [
        {
          required: true,
          message: '推荐分值不能为空',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.validate.valuesGreaterThan0
          },
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '题目基本信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'questionType',
          label: '题目类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.questionType
          }
        },
        {
          key: 'questionAccess',
          label: '题目权限',
          type: 'select',
          options: (params) => {
            return params.dictionarys.access
          }
        },
        {
          key: 'knowledgeType',
          label: '知识点类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.dataType
          },
          placeholder: '尽量按字典选择，没有可自行输入；可选多个',
          multiple: true,
          filterable: true,
          create: true
        },
        {
          key: 'knowledgeLabels',
          label: '知识点标签',
          type: 'input',
          placeholder: '请输入涉及知识类型的细化标签以方便更高效的查询'
        },
        {
          key: 'applicableUsers',
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return params.dictionarys.applicableUsers
          },
          placeholder: '尽量按字典选择，没有可自行输入；可选多个',
          multiple: true,
          filterable: true,
          create: true
        },
        {
          key: 'questionDifficulty',
          label: '题目难度',
          type: 'select',
          options: (params) => {
            return params.dictionarys.difficulty
          }
        },
        {
          key: 'content',
          label: '题目内容',
          type: 'input',
          inputType: 'textarea',
          inputTip: (params) => {
            return params.formValues && params.formValues.contentImgMatch
              ? '含' + params.formValues.contentImgMatch.length + '张图表'
              : ''
          },
          check: '编辑题干图表',
          autosize: true
        },
        {
          key: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? 'option'
              : null
          },
          label: '题目选项',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          readonly: true,
          check: '设置题目选项',
          placeholder: '请通过设置题目选项弹窗设置选项及答案'
        },
        {
          key: 'score',
          label: '推荐分值',
          type: 'input',
          number: true
        },
        {
          key: 'answers',
          label: '参考答案',
          type: (params) => {
            return params.formValues &&
              params.formValues.questionType === '判断题'
              ? 'select'
              : 'input'
          },
          inputType: 'textarea',
          autosize: true,
          options: (params) => {
            return params.formValues &&
              params.formValues.questionType === '判断题'
              ? [
                  { value: 'true', label: '正确' },
                  { value: 'false', label: '错误' }
                ]
              : []
          },
          readonly: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? true
              : false
          },
          check: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? '设置题目答案'
              : null
          }
        },
        {
          key: 'analysis',
          label: '题目解析',
          type: 'input',
          inputType: 'textarea',
          inputTip: (params) => {
            return params.formValues && params.formValues.analysisImgMatch
              ? '含' + params.formValues.analysisImgMatch.length + '张图表'
              : ''
          },
          check: '编辑解析图表',
          autosize: true
        }
      ]
    },
    options: options,
    imgTables: imgTables,
    uploadQuestion: uploadQuestion,
    resetDifficulty: {
      title: '按正确率重置题目难度',
      addFun: 'onlineExam/resetQuestionDifficulty',
      getParentFun: 'onlineExam/getQuestionList',
      formParams: {
        minSubmit: 20,
        easyRate: 80,
        hardRate: 50
      },
      formRules: {
        minSubmit: [
          { required: true, message: '请输入答题次数阈值', trigger: 'blur' }
        ],
        easyRate: [
          { required: true, message: '请输入简单正确率阈值', trigger: 'blur' }
        ],
        hardRate: [
          { required: true, message: '请输入困难正确率阈值', trigger: 'blur' }
        ]
      },
      formData: [
        {
          key: 'minSubmit',
          label: '答题次数阈值',
          type: 'input',
          number: true,
          placeholder: '达到该次数才重置',
          span: 18
        },
        {
          key: 'easyRate',
          label: '简单正确率≥',
          type: 'input',
          number: true,
          inputButton: '%',
          span: 18
        },
        {
          key: 'hardRate',
          label: '困难正确率≤',
          type: 'input',
          number: true,
          inputButton: '%',
          span: 18
        },
        {
          key: 'resetTip',
          type: 'tag',
          tag: '仅处理本机构题目中答题次数达到阈值的。中间区间重置为「中等」。不改题干与试卷关联。',
          span: 18
        }
      ]
    },
    batchTagLabels: {
      title: '批量加标签',
      addFun: 'onlineExam/batchUpdateQuestionTags',
      formParams: {
        knowledgeType: [],
        applicableUsers: []
      },
      formRules: {},
      formData: [
        {
          key: 'knowledgeType',
          label: '知识点类型',
          type: 'select',
          options: (params) => {
            return [{ label: '未分类', value: '未分类' }].concat(
              params.dictionarys.dataType || []
            )
          },
          multiple: true,
          filterable: true,
          create: true,
          placeholder: '尽量按字典选择，没有可自行输入；可选多个',
          span: 18
        },
        {
          key: 'applicableUsers',
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return [{ label: '未分类', value: '未分类' }].concat(
              params.dictionarys.applicableUsers || []
            )
          },
          multiple: true,
          filterable: true,
          create: true,
          placeholder: '尽量按字典选择，没有可自行输入；可选多个',
          span: 18
        },
        {
          key: 'tagTip',
          type: 'tag',
          tag: '请先勾选题目再打开本弹窗。未选择的一类不改动；选择后将覆盖已勾选题目的对应标签。',
          span: 18
        }
      ]
    }
  },
  paperQuestion: {
    name: 'paperQuestion',
    componentTypes: [
      'navigate',
      'check',
      'tables',
      'stepForm',
      'dialogTable',
      'drawerTable',
      'dialogForm'
    ], // 该页面包含的组件名称，用于判断是否返回页面渲染参数
    editFun: 'onlineExam/editPaperQuestion',
    getListFun: 'onlineExam/getPaperInfo',
    deleteFun: 'onlineExam/deletePaperQuestion',
    detailPage: [
      {
        buttonName: '创建试题',
        name: 'createQuestion',
        type: 'dialogForm',
        pageStatus: 'create'
      },
      {
        buttonName: '编辑',
        name: 'paperQuestion',
        type: 'stepForm',
        theme: 'onlineExam',
        step: 'paperQuestionInfo',
        label: '编辑试卷题目',
        checkType: 'useRowData'
      },
      {
        buttonNames: ['设置题目选项', '设置题目答案'],
        name: 'options',
        type: 'dialogForm'
      },
      {
        buttonNames: ['编辑题干图表', '编辑解析图表'],
        name: 'imgTables',
        type: 'dialogForm'
      }
    ],
    headButtons: (params) => {
      // 未确认试卷可组卷选题；勿用列表行 disabledButtons[0]（编辑禁用）误判
      const paper = resolvePaperCurrentRow(params)
      const status = paper && paper.paperStatus
      if (status === '3' || status === '已确认') return null
      return setCheckButtons(['创建试题'])
    },
    tagType: (params) => {
      const tagInfo = onlineExam.paperQuestion.tagInfo(params)
      return tagInfo && tagInfo.slice(0, 2) === '注意' ? 'danger' : ''
    },
    tagInfo: (params) => {
      var tagInfo = params.state.onlineExam.paperInfo.questionInfo
      const questionList = params.getters['onlineExam/questionList']
      const questionClass = !params.radio
        ? {}
        : classifyArray(
            questionList,
            params.radio !== '全部' ? 'score' : 'questionBankUid'
          )
      var questionExplain = ''
      for (const key in questionClass) {
        if (Object.hasOwnProperty.call(questionClass, key)) {
          const questionCodes = getSameAttribute(
            questionClass[key],
            'questionCode'
          ).values.map((code) => code.slice(0, -1))
          if (params.radio !== '全部') {
            questionExplain =
              (questionExplain ? questionExplain + '；' : '') +
              '第\xa0\xa0' +
              questionCodes[0] +
              '\xa0\xa0题至第\xa0\xa0' +
              questionCodes[questionCodes.length - 1] +
              '\xa0\xa0题每小题为\xa0\xa0' +
              key +
              '\xa0\xa0分'
          } else if (questionCodes.length > 1) {
            questionExplain =
              (questionExplain ? questionExplain + '；' : '') +
              '(第' +
              questionCodes.join('题、第') +
              '题)'
          }
        }
      }
      if (params.radio !== '全部') {
        tagInfo =
          '【' +
          params.radio +
          '】\xa0\xa0' +
          '本大题共\xa0\xa0' +
          questionList.length +
          '\xa0\xa0道小题。' +
          (Object.keys(questionClass).length === 1
            ? '每小题\xa0\xa0' + questionList[0].score + '\xa0\xa0分'
            : '其中' + questionExplain) +
          '，共计\xa0\xa0' +
          getSameAttribute(questionList, 'score').addValue +
          '\xa0\xa0分。'
      } else {
        tagInfo = questionExplain
          ? '注意：以下题目来源题库同一题目，请检查是否重复。' +
            questionExplain +
            ''
          : tagInfo
      }
      return tagInfo
    },
    radios: (params) => {
      const questionType =
        params.state.onlineExam.paperInfo.questionTypesIncluded
      var radios = ['全部'].concat(questionType)
      return radios
    },
    outListHeight: 310,
    nonHeader: true,
    expandColumn: true,
    border: false,
    expandAll: true,
    rowData: (params) => {
      return params.getters['onlineExam/questionList']
    },
    columns: (params) => {
      var columns = [
        {
          label: '序号',
          prop: 'questionCode',
          width: '30px'
        },
        {
          label: '题目类型',
          prop: 'questionType',
          width: '60px',
          tag: (params) => {
            return params.dictionarys.questionType
          }
        },
        {
          label: '题目分值',
          prop: 'questionScore',
          width: '65px'
        },
        {
          label: '题目内容',
          prop: 'content',
          align: 'left',
          overflow: false
        }
      ]
      const paper = resolvePaperCurrentRow(params)
      const status = paper && paper.paperStatus
      const locked = status === '3' || status === '已确认'
      if (paper && !locked) {
        columns.push({
          label: '操作',
          width: '220px',
          buttons: setTableButtons(['编辑', '删除'])
        })
      }
      return columns
    },
    hasPagination: true,
    formParams: {
      orgUid: (params) => {
        return params.orgValue
      },
      paperUid: '',
      questionType: '',
      questionContent: '',
      options: [],
      correctAnswer: [],
      questionAnalysis: '',
      score: null
    },
    formRules: {
      questionType: [
        { required: true, message: '题目类型不能为空', trigger: 'blur' }
      ],
      content: [
        { required: true, message: '题目内容不能为空', trigger: 'blur' }
      ],
      option: [
        {
          required: (params) => {
            return (
              params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
            )
          },
          message: '选项不能为空',
          trigger: 'change'
        }
      ],
      answers: [
        {
          required: true,
          message: '正确答案不能为空',
          trigger: 'change'
        },
        {
          validator: (params) => {
            return params.validate.validateAnswers
          },
          trigger: 'change'
        }
      ],
      score: [
        {
          required: true,
          message: '题目分值不能为空',
          trigger: 'blur'
        },
        {
          validator: (params) => {
            return params.validate.valuesGreaterThan0
          },
          trigger: 'change'
        }
      ]
    },
    formData: {
      card: '试卷试题信息',
      bottomButtons: setFormButtons(['取消', '提交']),
      fields: [
        {
          key: 'questionType',
          label: '题目类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.questionType
          }
        },
        {
          key: 'content',
          label: '题目内容',
          type: 'input',
          inputType: 'textarea',
          inputTip: (params) => {
            return params.formValues && params.formValues.contentImgMatch
              ? '含' + params.formValues.contentImgMatch.length + '张图表'
              : ''
          },
          check: '编辑题干图表',
          autosize: true
        },
        {
          key: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? 'option'
              : null
          },
          label: '题目选项',
          type: 'input',
          inputType: 'textarea',
          autosize: true,
          readonly: true,
          check: '设置题目选项'
        },
        {
          key: 'score',
          label: '题目分值',
          type: 'input',
          number: true
        },
        {
          key: 'answers',
          label: '参考答案',
          type: (params) => {
            return params.formValues &&
              params.formValues.questionType === '判断题'
              ? 'select'
              : 'input'
          },
          inputType: 'textarea',
          autosize: true,
          options: (params) => {
            return params.formValues &&
              params.formValues.questionType === '判断题'
              ? [
                  { value: 'true', label: '正确' },
                  { value: 'false', label: '错误' }
                ]
              : []
          },
          readonly: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? true
              : false
          },
          check: (params) => {
            return params.formValues &&
              (params.formValues.questionType === '单选题' ||
                params.formValues.questionType === '多选题')
              ? '设置题目答案'
              : null
          }
        },
        {
          key: 'analysis',
          label: '题目解析',
          type: 'input',
          inputType: 'textarea',
          inputTip: (params) => {
            return params.formValues && params.formValues.analysisImgMatch
              ? '含' + params.formValues.analysisImgMatch.length + '张图表'
              : ''
          },
          check: '编辑解析图表',
          autosize: true
        }
      ]
    },
    options: options,
    imgTables: imgTables,
    createQuestion: {
      name: 'createQuestion',
      title: '添加或生成试题',
      getParentFun: 'onlineExam/getPaperInfo',
      formParams: {
        orgUid: (params) => {
          return params.orgValue
        },
        knowledgeType: [],
        applicableUsers: [],
        questionRules: [{ questionType: '', questionNum: null, score: null }],
        createRules: '',
        query: '',
        createType: '按模版生成'
      },
      formRules: {
        knowledgeType: [
          {
            required: true,
            message: '请至少选择一个知识点类型',
            trigger: 'blur',
            type: 'array'
          }
        ],
        applicableUsers: [
          {
            required: true,
            message: '请至少选择一个适用对象',
            trigger: 'blur',
            type: 'array'
          }
        ],
        createType: [
          { required: true, message: '试题创建方式不能为空', trigger: 'blur' }
        ],
        createRules: [
          {
            required: (params) => {
              return (
                params.formValues &&
                params.formValues.createType === '按模版生成'
              )
            },
            message: '请选择一个试卷模版',
            trigger: 'blur'
          },
          {
            validator: (params) => {
              return params.validate.validateCreateRules
            },
            trigger: 'change'
          }
        ],
        questionRules: [
          {
            validator: (params) => {
              return (rule, value, callback) => {
                const form = (params && params.formValues) || {}
                if (form.createType && form.createType !== '自定义生成') {
                  callback()
                  return
                }
                if (!value || !value.length) {
                  callback('请至少添加一种题型')
                  return
                }
                const types = []
                for (let i = 0; i < value.length; i++) {
                  const row = value[i] || {}
                  if (!row.questionType) {
                    callback('第' + (i + 1) + '行请选择题型')
                    return
                  }
                  if (types.indexOf(row.questionType) > -1) {
                    callback('题型「' + row.questionType + '」重复')
                    return
                  }
                  types.push(row.questionType)
                  const num = Number(row.questionNum)
                  if (!num || num <= 0 || parseInt(num, 10) !== num) {
                    callback(
                      '题型「' + row.questionType + '」的题目数量须为正整数'
                    )
                    return
                  }
                  const score = Number(row.score)
                  if (!score || score <= 0) {
                    callback(
                      '题型「' + row.questionType + '」的每题分数须大于0'
                    )
                    return
                  }
                }
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      formData: [
        {
          key: 'createType',
          label: '试题创建方式',
          type: 'select',
          options: [
            { value: 'createModel', label: '按模版生成' },
            { value: 'createRule', label: '自定义生成' },
            { value: 'searchAdd', label: '搜索添加' }
          ],
          placeholder: '请选择创建试题的方式',
          span: 18
        },
        {
          type: 'tag',
          tag: (params) => {
            return params.formValues &&
              params.formValues.createType === '按模版生成'
              ? '提示：每份试卷只选择一个模版，按模版中配置的各题型数量与分值自动抽题；若没有合适模版，请先到「系统字段 / 试卷模版」中新增'
              : params.formValues &&
                params.formValues.createType === '自定义生成'
              ? '提示：可一次添加多种题型，分别设置数量和每题分值；生成后的总分不能超过创建试卷时确定的总分'
              : '提示：按照表单中条件在题库中搜索相应题目然后手动添加'
          },
          span: 18
        },
        {
          key: 'createRules',
          isShow: (params) => {
            return (
              params.formValues && params.formValues.createType === '按模版生成'
            )
          },
          label: '试卷模版',
          type: 'select',
          options: (params) => {
            return (
              params.dictionarys.createPaperTemplates ||
              params.dictionarys.createPaperModel ||
              []
            )
          },
          filterable: true,
          clearable: true,
          checkByValue: true,
          placeholder: '请选择一个试卷模版',
          span: 18
        },
        {
          key: 'knowledgeType',
          label: '知识点类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.dataType
          },
          multiple: true,
          placeholder: '请选择知识点类型框选试题范围',
          span: 18
        },
        {
          key: 'query',
          label: '知识点标签',
          type: 'input',
          placeholder: '请输入知识点标签中进一步缩小试题范围',
          span: 18
        },
        {
          key: 'applicableUsers',
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return params.dictionarys.applicableUsers
          },
          multiple: true,
          placeholder: '请至选择适用对象框选试题范围',
          span: 18
        },
        {
          key: 'questionRules',
          isShow: (params) => {
            return (
              params.formValues && params.formValues.createType === '自定义生成'
            )
          },
          label: '题型规则',
          type: 'table',
          editable: true,
          span: 18,
          maxHeight: 280,
          headButtons: setCheckButtons([
            { name: '添加题型', code: 'addQuestionRule' }
          ]),
          columns: [
            {
              prop: 'questionType',
              label: '题目类型',
              editType: 'select',
              options: (params) => params.dictionarys.questionType,
              minWidth: '140px'
            },
            {
              prop: 'questionNum',
              label: '题目数量',
              editType: 'input',
              number: 0,
              minWidth: '110px'
            },
            {
              prop: 'score',
              label: '每题分数',
              editType: 'input',
              number: true,
              minWidth: '110px'
            },
            {
              label: '操作',
              width: '90px',
              buttons: setTableButtons([
                { name: '移除', code: 'removeQuestionRule' }
              ])
            }
          ]
        }
      ]
    },
    addQuestion: {
      name: 'addQuestion',
      title: '请勾选题目并添加到试卷',
      size: '45%',
      direction: 'rtl',
      getListFun: 'onlineExam/getQuestionList',
      getParentFun: 'onlineExam/getQuestionInfo',
      headButtons: setCheckButtons(['添加到试卷']),
      selectColumn: '30px',
      expandColumn: '30px',
      border: false,
      expandAll: true,
      outListHeight: 380,
      queryParams: {
        orgUid: (params) => {
          return params.orgValue
        },
        scope: (params) => {
          return publicPickScope(
            params.getters && params.getters['user/pages'],
            'onlineExam',
            '公共试题库',
            params.userName,
            params.state && params.state.superAdminName
          )
        },
        knowledgeType: [],
        applicableUsers: [],
        questionType: '',
        query: ''
      },
      selectData: [
        {
          key: 'knowledgeType',
          label: '知识点类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.dataType
          },
          multiple: true,
          collapseTags: true,
          placeholder: '请选择知识点类型框选试题范围'
        },
        {
          key: 'query',
          label: '知识点标签',
          type: 'input',
          placeholder: '请输入知识点标签中进一步缩小试题范围'
        },
        {
          key: 'applicableUsers',
          label: '适用对象',
          type: 'select',
          options: (params) => {
            return params.dictionarys.applicableUsers
          },
          multiple: true,
          collapseTags: true,
          placeholder: '请至选择适用对象框选试题范围'
        },
        {
          key: 'questionType',
          label: '题目类型',
          type: 'select',
          options: (params) => {
            return params.dictionarys.questionType
          }
        }
      ],
      selectable: () => (row) => !(row && row.paperAdded),
      scoreGuard: (params) => (rows) => {
        const paper =
          params.state && params.state.onlineExam
            ? params.state.onlineExam.paperInfo
            : null
        const add = (rows || []).reduce(
          (sum, item) => sum + (Number(item && item.score) || 0),
          0
        )
        return scoreOverflowMessage(paper, add)
      },
      tagInfo:
        '请在下面题库列表中勾选符合要求的题目，可根据实际情况修改默认分值。已在本试卷中的题目会标记且不能再次勾选。',
      rowData: (params) => {
        return params.state.onlineExam.questionList.result
      },
      rowTotal: (params) => {
        return params.state.onlineExam.questionList.totalSize
      },
      columns: [
        {
          label: '题目类型',
          prop: 'questionType',
          width: '100px',
          tag: (params) => {
            return params.dictionarys.questionType
          }
        },
        {
          label: '题目内容',
          prop: 'content',
          align: 'left',
          overflow: false
        },
        {
          label: '状态',
          prop: 'paperAddedText',
          width: '80px'
        },
        {
          label: '题目分值',
          prop: 'score',
          width: '100px',
          formItem: {
            type: 'input'
          },
          number: true
        }
      ],
      hasPagination: true
    }
  }
}

export default onlineExam
